import {useIntl} from "react-intl";
import styles from "./index.module.scss";
import {URL} from "utils";

function InformationPopup({dismiss}) {
  const intl = useIntl();
  const closePopup = () => {
    dismiss();
  };

  const openOuterPage = () => {
    if (intl.locale === "kr") {
      window.open(URL.WIKI);
    } else {
      window.open(" https://redbrick.gitbook.io/wiki-main/v/en/");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.information}>
        <div className={styles.title}>
          {intl.formatMessage({
            id: "ID_INFORMATION_POPUP_TITLE",
          })}
        </div>
        <div className={styles.content}>
          {intl.formatMessage({
            id: "ID_INFORMATION_POPUP_CONTENT",
          })}
        </div>
        <div className={styles.link} onClick={openOuterPage}>
          <div className={styles.link_content}>
            {intl.formatMessage({
              id: "ID_INFORMATION_POPUP_LINK_BTN",
            })}
          </div>
        </div>
      </div>
      <div className={styles.button_container}>
        <div className={styles.close_btn} onClick={closePopup}>
          <div className={styles.close_btn_content}>
            {intl.formatMessage({
              id: "ID_INFORMATION_POPUP_CLOSE_BTN",
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InformationPopup;
